import ReferenceDataItem from "./referenceDataItem";

export class ProjectedTeamReferenceDataItem extends ReferenceDataItem {
    IsDirectlyAssigned: boolean;
    ExternalGroupNames: string[];
}

export default ProjectedTeamReferenceDataItem;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/projectedTeamReferenceDataItem.ts